module.exports = __webpack_public_path__ + "static/Who-Were-the-Vikings-49d64ed4e04ed33229d733e27b94d341.pdf";